module.exports = __webpack_public_path__ + "img/69.fe3ce8da.jpg";